export default function EquipmentSearchFactory(equipmentRepository, $q) {
  'ngInject';
  //Creates an instance of the factory
  var self = {};
  self.limit = 15;
  self.searchString = "";
  self.data = {};


  self.refreshFilterCount = function () {
    if (self.data && self.data.tagFilters) {
      self.filterCount = Object.keys(self.data.tagFilters).length;
    }

    if (self.data && self.data.facets) {

      for (var key in self.data.facets) {
        for (var i = 0; i < self.data.facets[key].length; i++) {
          if (self.data.facets[key][i]._selected) {
            self.filterCount++;
          }
        }
      }
    }
  };

  self.getCurrentPage = function () {
    return self.page;
  };

  self.clearSearch = function () {
    self.isFiltered = false;
    self.filters = {};
    self.searchString = "";
    self.queryString = "";
  };

  self.setResponseData = function (responseData) {
    self.responseData = responseData;
  };

  self.getQueryString = function () {

    var result = '*';

    if (self.searchString && self.searchString.length > 0) {
      result = self.searchString;
    }

    return result;
  };

  self.calculatePages = function () {
    self.pages = [];

    self.numPages = Math.ceil(self.responseData.data.total / self.limit);

    //if the number of assets is lower then the limit, must be on the first page.
    if (self.responseData.data.cursor < self.limit) {
      self.page = 1;
    }
    //always return a page higher if not equally divisible
    else {
      self.page = Math.ceil(self.responseData.data.cursor / self.limit);
    }
    var concurrentPages = 1;

    var cursor = self.page - Math.ceil(concurrentPages / 2);
    var addedPages = 0;

    if (cursor < 0) {
      cursor = 0;
    }

    self.showingLastPage = false;
    self.showingFirstPage = false;

    while (self.pages.length < concurrentPages) {
      if (cursor < self.numPages) {
        self.pages.push(cursor + 1);
        cursor++;

        if (cursor == 1) {
          self.showingFirstPage = true;
        }

        if (cursor == self.numPages) {
          self.showingLastPage = true;
        }
      } else {
        break;
      }
    }
  };

  self.selectPage = function (page) {
    self.selectedPage = page;
  };

  self.sinceForPage = function (page, limit) {
    return (page - 1) * limit;
  };

  self.getSearchOptions = function () {
    var options = {};
    options.limit = self.limit || 500;
    if (self.selectedPage) {
      options.since = self.sinceForPage(self.selectedPage, self.limit);
    }

    return options;
  };

  self.getStateParams = function () {
    var stateParams = {};

    var params_tags = [];
    stateParams["page"] = self.selectedPage;
    stateParams["limit"] = self.limit;
    stateParams["q"] = self.searchString;

    if (self.tagFilters) {

      for (var i = 0; i < self.tagFilters.length; i++) {
        params_tags.push(self.tagFilters[i].id);
      }

      stateParams["tags"] = params_tags;
    }

    if (self.data.facets) {
      var facets = [];

      for (var key in self.data.facets) {
        var result = [];
        var prefix = "onei3:";
        for (var i = 0; i < self.data.facets[key].length; i++) {
          if (self.data.facets[key][i]._selected) {
            var tag = self.data.facets[key][i].tag;
            var storedTag = tag.slice(prefix.length);
            result.push(storedTag);
          }

        }
        stateParams[key] = result;
      }
    }

    if (self.data.tagFilters) {

      stateParams["tags"] = JSON.stringify(self.data.tagFilters);
    }
    return stateParams;

  };

  self.onFacetsChange = function () {

    self.refreshSearch();
  };

  self.refreshSearch = function () {
    self.selectPage(1);
    self.refreshFilterCount();
    self.search();
  };

  self.search = function () {

    var def = $q.defer();

    self.loading = true;
    equipmentRepository.getEquipmentSearch(self.getQueryString(), self.getSearchOptions(), self.filters, null, null, self.data.facets, self.data.tagFilters)
      .then(function (response, status, headers) {
        self.ready = true;

        self.setResponseData(response);
        self.loading = false;
        self.calculatePages();

        if (self.isDirty)
          self.search();

        def.resolve(response);
      }, function (response) {
        self.isSearchLoading = false;
        self.isMoreLoading = false;
        var errorMsg = gettextCatalog.getString("An error occurred while retrieving asset information");
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
          } else {
            errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString(". Please try again later.");
        }
        self.errorFlag = true;
        self.errorText = errorMsg;

        def.reject(response);
      }).finally(function () {

        self.loading = false;

        self.loading = false;

      });

    return def.promise;
  };


  self.loadStateParams = function ($stateParams) {

    if ($stateParams.page) {
      self.selectedPage = $stateParams.page;
    }

    self.searchString = $stateParams.q;

    var facetsToLoad = [{
        name: "maintenance",
        prefix: "onei3:maintenance:"
      },
      {
        name: "securityGroups",
        prefix: "onei3:security:group"
      },
      {
        name: "alerts",
        prefix: "onei3:alert:"
      }
    ];

    for (var k = 0; k < facetsToLoad.length; k++) {

      var key = facetsToLoad[k].name;

      var result = [];
      var prefix = facetsToLoad[k].prefix;
      if ($stateParams[key]) {

        var stateParams = [];

        if (Object.prototype.toString.call($stateParams[key]) !== '[object Array]') {

          stateParams.push($stateParams[key]);
        } else {
          stateParams = $stateParams[key];
        }

        if (!self.data.facets) {
          self.data.facets = {};
        }

        //Look through all of the state params for this key... and append it ot the thingies
        for (var i = 0; i < stateParams.length; i++) {

          var stateParam = stateParams[i];

          if (!self.data.facets[key]) {
            self.data.facets[key] = [];
          }

          self.data.facets[key].push({
            tag: "onei3:" + stateParams[i],
            _selected: true
          });
        }
      }
    }

    if ($stateParams) {
      if ($stateParams["tags"]) {
        self.data.tagFilters = JSON.parse($stateParams["tags"]);
      }
    }

    self.refreshFilterCount();
  };

  return self;
}